import React, {Component} from 'react'
import Img from 'gatsby-image'
import Grid from '../Grid'

class ImageGrid extends Component {

  render() {
    console.log(this.props.images);
    let images = this.props.images.map(
      (image, index) =>
        <div key={index}>
        <Img fluid = {this.props.images[index].node.childImageSharp.fluid}></Img>
        </div>
    );

    return (
      <Grid
        data = {images}
        nCellsPerRow = {this.props.nCellsPerRow}
        nCellsPerRowMobile = {this.props.nCellsPerRowMobile}
      ></Grid>
    );
  }
}

export default ImageGrid
